import classnames from 'classnames';
import PropTypes from 'prop-types';

/**
 * Phase 4.6 shim. Faithfully reproduces react-bootstrap 0.31's `<Checkbox>` DOM
 * so we can drop the rb-0.31 dependency without touching the (heavily themed)
 * .checkbox SCSS. Used as the `component` of react-redux-form's Control.checkbox,
 * exactly like the old rb Checkbox. The BS3 classnames retire wholesale at the
 * bootstrap-v5 cutover.
 */
const BsCheckbox = ({
  inline = false, disabled = false, validationState, inputRef, className, style, title, children, ...props
}) => {
  const input = <input {...props} ref={inputRef} type="checkbox" disabled={disabled}/>;

  if (inline) {
    return (
      <label className={classnames(className, 'checkbox-inline', { disabled })} style={style} title={title}>
        {input}
        {children}
      </label>
    );
  }

  return (
    <div
      className={classnames(className, 'checkbox', {
        disabled,
        [`has-${validationState}`]: validationState
      })}
      style={style}
    >
      <label title={title}>
        {input}
        {children}
      </label>
    </div>
  );
};

BsCheckbox.propTypes = {
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  validationState: PropTypes.oneOf(['success', 'warning', 'error', null]),
  inputRef: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default BsCheckbox;
